import {Button} from '@kidslabs/mario-ui-nextjs-react-core';
import {Form} from '@/_application/core/components/ui/forms/form';
import PasswordInput from '@/_application/core/components/ui/forms/password-input';
import {toastSuccessMessage} from '@/_application/core/components/ui/toast/toast';
import {
    UpdateInfoInput,
    useUpdateCustomerInfoForm,
} from '@/_application/modules/customers/hooks/use-update-customer-info-form';
import {useTranslation} from 'next-i18next';
import {useEffect} from 'react';
import {toast} from 'react-toastify';
import {useChangeCustomerPassword} from '@/framework/customer';
import {useModalAction} from '@/_application/core/components/ui/modal/modal.context';

export default function UpdatePassword() {
    const {t} = useTranslation();
    const {updateInfoRequestSchema, initialValue, resetValues, setResetValues} = useUpdateCustomerInfoForm();
    const {changeCustomerPassword} = useChangeCustomerPassword();
    const {closeModal} = useModalAction();

    useEffect(() => {
        setResetValues({...initialValue, isChangePassword: true});
    }, []);

    const onSubmit = async (data: any) => {
        const {currentPassword, newPassword} = data;
        if (currentPassword === newPassword) {
            toast.error(t('error-same-old-password'), {
                toastId: 'error-same-old-password',
            });
            setResetValues({...initialValue, isChangePassword: true});
            return;
        }

        changeCustomerPassword(currentPassword, newPassword)
            .then(res => {
                if (res.data) {
                    toastSuccessMessage(t('password-successful'));
                    closeModal();
                }
            })
            .finally(() => {
                setResetValues({...initialValue, isChangePassword: true});
            });
    };

    return (
        <Form<UpdateInfoInput>
            className="flex w-full flex-col gap-1 p-5"
            onSubmit={onSubmit}
            validationSchema={updateInfoRequestSchema}
            resetValues={resetValues ?? {}}
            useFormProps={{
                defaultValues: initialValue,
            }}>
            {({control, register, formState: {errors}}) => (
                <div className="flex min-w-180 flex-col rounded-2xl bg-white px-12 py-8">
                    <p className="m-auto text-xl font-bold text-primary">Thay đổi mật khẩu</p>
                    <div className="mt-8 flex flex-col gap-3">
                        <PasswordInput
                            required
                            {...register('currentPassword')}
                            label={t('text-your-current-password')}
                            error={errors.currentPassword?.message}
                        />
                        <PasswordInput
                            required
                            {...register('newPassword')}
                            label={t('text-your-new-password')}
                            error={errors.newPassword?.message}
                        />

                        {/* <PasswordInput name="confirmPassword" label="Nhập lại mật khẩu" error={''} /> */}
                        <Button
                            type="submit"
                            size="small"
                            variant="custom"
                            aria-label="Cập nhật mật khẩu"
                            className="m-auto mt-5 w-28 rounded-lg bg-primary text-white">
                            {t('text-update')}
                        </Button>
                    </div>
                </div>
            )}
        </Form>
    );
}
